<script>
  import { createEventDispatcher } from "svelte";
  import NauiButton from "../naui/atoms/NauiButton.svelte";

  export let items = [];
  export let activeTabValue = 1;
  export let closePopUp;
  const dispatch = createEventDispatcher();

  let formData = {};

  const handleClick = (tabValue) => () => {
    activeTabValue = tabValue;
    dispatch("tabChange", { activeTabValue, items, formData });
  };

  const nextTab = () => {
    const currentIndex = items.findIndex(
      (item) => item.value === activeTabValue
    );
    if (currentIndex < items.length - 1) {
      activeTabValue = items[currentIndex + 1].value;
      dispatch("tabChange", { activeTabValue, items, formData });
    }
  };

  const prevTab = () => {
    const currentIndex = items.findIndex(
      (item) => item.value === activeTabValue
    );
    if (currentIndex > 0) {
      activeTabValue = items[currentIndex - 1].value;
      dispatch("tabChange", { activeTabValue, items, formData });
    }
  };

  function handleUpdate(event) {
    formData[event.detail.label] = event.detail.data;
    dispatch("tabChange", { activeTabValue, items, formData });
  }
</script>

<ul>
  {#each items as item}
    <li class={activeTabValue === item.value ? "active" : ""}>
      <span on:click={handleClick(item.value)}>{item.label}</span>
    </li>
  {/each}
</ul>

{#each items as item}
  <div class="box {activeTabValue === item.value ? 'active' : 'hidden'}">
    <svelte:component this={item.component} {...item.props} on:update={handleUpdate} />
  </div>
{/each}

<div class="stepper">
  <div class="stepperLeft">
    <NauiButton
      caption="Anterior"
      color="accent"
      mode="outline"
      on:click={prevTab}
      disabled={activeTabValue === items[0].value}
    />
    <NauiButton
      caption="Siguiente"
      color="accent"
      mode="outline"
      on:click={nextTab}
      disabled={activeTabValue === items[items.length - 1].value}
    />
  </div>
</div>

<style>
  .box {
    display: none;
  }
  .box.active {
    display: block;
  }
  .box.hidden {
    display: none;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    border-bottom: 1px solid #dee2e6;
  }
  li {
    margin-bottom: -1px;
  }
  span {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
    display: block;
    padding: 0.5rem 1rem;
    cursor: pointer;
  }
  span:hover {
    border-color: #e9ecef #e9ecef #dee2e6;
  }
  li.active > span {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
  }
  .stepper {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: #fff;
    padding: 10px;
    z-index: 10;
    margin-top: 10px;
  }

  .stepperLeft {
    display: flex;
    flex-direction: row;
    width: 25%;
    justify-content: space-between;
  }

  @media (max-width: 600px) {
    .stepper {
      flex-direction: column;
      align-items: center;
    }
  }
  @media (max-width: 600px) {
    ul {
      flex-direction: column;
    }
    li {
      width: 100%;
    }
    .box {
      padding: 20px;
    }
  }
</style>
